export default __webpack_public_path__ + "static/media/PPI-walkway-009.ae7f63e2.jpg";